import React from "react";
import { RouterProvider } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";
import { router } from "./Router";
import { creativeTheme } from "./libs/theme/theme";
import { SnackbarProvider } from "notistack";
import { LoadingFullPage } from "./pages";
import { useRouterStore } from "./libs/stores";


export const App = () => {
  const getQualityPhoto = useRouterStore((state) => state.getQualityPhoto);


  React.useEffect(() => {
    getQualityPhoto();
  }, []);

  return (
    <SnackbarProvider maxSnack={3} hideIconVariant={false} dense>
      <ThemeProvider theme={creativeTheme}>
        <React.Suspense fallback={<LoadingFullPage />}>
          <RouterProvider
            router={router}
            fallbackElement={<CircularProgress />}
          />
        </React.Suspense>
      </ThemeProvider>
    </SnackbarProvider>
  );
};
